module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-normal.2b5c69c4.png";